import { createAction, handleActions } from 'redux-actions';

export const types = {
  apiStatus: 'API_STATUS',
};

export const apiStatus = createAction(types.apiStatus);

export const INITIAL_STATE = {
  connected: false,
  offline: 'offline mode',
  error: '',
};

export const apiReducer = handleActions(
  {
    [types.apiStatus]: (state, action) => ({
      ...state,
      connected: action.payload.connected,
      offline: action.payload.offline,
      error: action.payload.error,
    }),
  },
  INITIAL_STATE
);
